var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignalPoor(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    className: "weak-signal",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 16.4,
    fill: "currentColor",
    y: 0,
    width: 1.6,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.3,
    y: 3,
    fill: "currentColor",
    width: 1.6,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.2,
    y: 7.3,
    fill: "currentColor",
    width: 1.6,
    height: 10.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.1,
    y: 10.2,
    fill: "#FF3B30",
    width: 1.6,
    height: 7.8
  }), /*#__PURE__*/React.createElement("rect", {
    y: 13.2,
    fill: "#FF3B30",
    width: 1.6,
    height: 4.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalPoor);
export default __webpack_public_path__ + "static/media/signalPoor.47ef3739c0ebbbf16f69a6c9c4e26cbf.svg";
export { ForwardRef as ReactComponent };